module.exports = __webpack_public_path__ + "static/media/bd.6ab6bba3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bd.svg
// module id = 778
// module chunks = 0